import { render, staticRenderFns } from "./uploadType.vue?vue&type=template&id=3ad3e37c&scoped=true"
import script from "./uploadType.vue?vue&type=script&lang=js"
export * from "./uploadType.vue?vue&type=script&lang=js"
import style0 from "./uploadType.vue?vue&type=style&index=0&id=3ad3e37c&prod&lang=scss&scoped=true"
import style1 from "./uploadType.vue?vue&type=style&index=1&id=3ad3e37c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3e37c",
  null
  
)

export default component.exports